module.exports = __webpack_public_path__ + "static/media/n95.6209d5a7.jpg";